/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { BankDropdownResponseDto } from '../model/bankDropdownResponseDto';
import { BankPaginationResponseDto } from '../model/bankPaginationResponseDto';
import { BankRequestDto } from '../model/bankRequestDto';
import { BankResponseDto } from '../model/bankResponseDto';
import { ValidationError } from '../model/validationError';

export enum banksDropdownGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum banksGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum banksIdGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class BanksService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public banksDropdownGet$(page?: number, limit?: number, name?: string, language?: string, isActive?: boolean, sort?: string): Observable<Array<BankDropdownResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/banks/dropdown`, { page, limit, name, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public banksGet$(page?: number, limit?: number, name?: string, language?: string, isActive?: boolean, sort?: string): Observable<BankPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/banks`, { page, limit, name, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public banksIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/banks/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public banksIdGet$(id: string, language?: string): Observable<BankResponseDto> {
    return this.api.get(`${apiBaseUrl()}/banks/${encodeURIComponent(String(id))}`, { language });
  }
  /**
   * [Authorize] type: http
   */
  public banksIdPut$(id: string, body: BankRequestDto): Observable<BankResponseDto> {
    return this.api.put(`${apiBaseUrl()}/banks/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public banksIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/banks/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public banksPost$(body: BankRequestDto): Observable<BankResponseDto> {
    return this.api.post(`${apiBaseUrl()}/banks`, body, undefined);
  }
}
